import { InputRow } from "../Rows";
import { useTranslation } from "react-i18next";
import { FormCard, FormGrid } from "../FormCard";

const PartnerForm = ({ partner, handleInputChange, title }) => {
  const { t } = useTranslation();
  return (
    <FormCard title={title ?? t("partner.details")}>
      <FormGrid>
        <InputRow
          label={t("common.organizationNumber")}
          value={partner?.organizationNumber || ""}
          onChange={(value) => handleInputChange("organizationNumber", value)}
          required
        />
        <InputRow
          label={t("common.name")}
          value={partner?.name || ""}
          onChange={(value) => handleInputChange("name", value)}
          required
        />
        <InputRow
          label={t("common.email")}
          value={partner?.email || ""}
          onChange={(value) => handleInputChange("email", value)}
          required
        />
        <InputRow
          label={t("common.address")}
          value={partner?.address || ""}
          onChange={(value) => handleInputChange("address", value)}
        />
        <InputRow
          label={t("common.zipCode")}
          value={partner?.zipCode || ""}
          onChange={(value) => handleInputChange("zipCode", value)}
        />
        <InputRow
          label={t("common.city")}
          value={partner?.city || ""}
          onChange={(value) => handleInputChange("city", value)}
        />
      </FormGrid>
    </FormCard>
  );
};

export default PartnerForm;
